module.exports = "/_next/static/images/contacts_fone-aced926de5bd8d14e7254957ae70d083.png";